webpackJsonp([165866024739752],{

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mile-high-boys-club2.7f361d2f.png";

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _mileHighBoysClub = __webpack_require__(753);
	
	var _mileHighBoysClub2 = _interopRequireDefault(_mileHighBoysClub);
	
	__webpack_require__(1135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Culture = function (_Component) {
	  _inherits(Culture, _Component);
	
	  function Culture() {
	    _classCallCheck(this, Culture);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Culture.prototype.componentDidMount = function componentDidMount() {
	
	    //add the dark style nav
	    document.querySelector('.footer__links').classList.add('catalog');
	    document.querySelector('.sideBar').classList.add('catalog');
	    document.querySelector('.sideBar__btn').classList.add('catalog');
	    document.querySelectorAll('li.topBar__link a').forEach(function (el) {
	      return el.classList.add('catalog');
	    });
	  };
	
	  Culture.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Mile High Boys Club | About us',
	        meta: [{ name: 'description', content: 'Mile High Boys Club official website and merch store. Browse our catalog' }, { name: 'keywords', content: 'Mile High Boys Club, MHBC, MHBC Fashion, fashion' }]
	      }),
	      _react2.default.createElement(
	        'header',
	        { className: 'about__header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'about__headerImg' },
	          _react2.default.createElement('img', { src: _mileHighBoysClub2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'about__headerTitle' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'About'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'learn about MHBC and the team running the show'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'main',
	        { className: 'about__main' },
	        _react2.default.createElement(
	          'section',
	          { className: 'about__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Never limit yourself based on past circumstances'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\'it all starts with an idea\'. You can achieve whatever you set your mind to. Milehighboysclub (MHBC) was established in Atlanta, GA in 2010. A mark of excellence. A multi-cultural and global brand that has no boundaries or limitations.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The CEO, Chris Thompson (Mr. P), also believed that how you present yourself speaks miles. Sadly however, the fashion industry was absent of a company that represented that theme. It seemed there were brands catered to the wealthy and the nons, no brands spoke to the creators, go-getters, and innovators; people who were wealthy but still striving to reach higher. With this in mind he decided to brand Mile high boys club and take on the fashion industry. "Aim high fly high"'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Culture;
	}(_react.Component);
	
	exports.default = Culture;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-culture-en-js-8dccec62273eb7a2496a.js